'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // Copyright (c) 2018 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _base = require('../../components/common/icons/base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HexagonLayerIcon = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HexagonLayerIcon, _Component);

  function HexagonLayerIcon() {
    (0, _classCallCheck3.default)(this, HexagonLayerIcon);
    return (0, _possibleConstructorReturn3.default)(this, (HexagonLayerIcon.__proto__ || Object.getPrototypeOf(HexagonLayerIcon)).apply(this, arguments));
  }

  (0, _createClass3.default)(HexagonLayerIcon, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _base2.default,
        this.props,
        _react2.default.createElement('polygon', {
          className: 'cr1',
          points: '23.9,10 30.9,14 30.9,22.1 23.9,26.2 16.8,22.1 16.8,14 ',
          style: { opacity: 0.6 }
        }),
        _react2.default.createElement('polygon', {
          className: 'cr2',
          points: '23.9,37.8 30.9,41.9 30.9,50 23.9,54 16.8,50 16.8,41.9 ',
          style: { opacity: 0.4 }
        }),
        _react2.default.createElement('polygon', {
          className: 'cr6',
          points: '40.1,10 47.2,14 47.2,22.1 40.1,26.2 33.1,22.1 33.1,14 '
        }),
        _react2.default.createElement('polygon', {
          className: 'cr3',
          points: '40.1,37.8 47.2,41.9 47.2,50 40.1,54 33.1,50 33.1,41.9 ',
          style: { opacity: 0.8 }
        }),
        _react2.default.createElement('polygon', {
          className: 'cr1',
          points: '15.8,23.9 22.8,27.9 22.8,36.1 15.8,40.1 8.7,36.1 8.7,27.9 '
        }),
        _react2.default.createElement('polygon', {
          className: 'cr4',
          points: '32,23.9 39,27.9 39,36.1 32,40.1 25,36.1 25,27.9 ',
          style: { opacity: 0.8 }
        }),
        _react2.default.createElement('polygon', {
          className: 'cr5',
          points: '48.2,23.9 55.3,27.9 55.3,36.1 48.2,40.1 41.2,36.1 41.2,27.9 ',
          style: { opacity: 0.4 }
        })
      );
    }
  }]);
  return HexagonLayerIcon;
}(_react.Component), _class.propTypes = {
  /** Set the height of the icon, ex. '16px' */
  height: _propTypes2.default.string,
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string)
}, _class.defaultProps = {
  height: '16px',
  predefinedClassName: 'hexagon-layer-icon',
  totalColor: 6
}, _temp);
exports.default = HexagonLayerIcon;
;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/kepler.gl/dist/layers/hexagon-layer/hexagon-layer-icon.js
// module id = 1443
// module chunks = 0